export interface EmailConfig {
  isTestEmail: boolean;
  apiKey: string | undefined;
  environment: "test" | "production";
}

export const TEST_EMAIL_PATTERNS = ["@sevencells.com"];

export const isTestEmail = (email: string): boolean => {
  if (!email || typeof email !== "string") {
    return false;
  }

  const lowerEmail = email.toLowerCase();

  return TEST_EMAIL_PATTERNS.some((pattern) => lowerEmail.includes(pattern.toLowerCase()));
};

export const getEmailConfig = (email: string): EmailConfig => {
  const isTest = isTestEmail(email);

  return {
    isTestEmail: isTest,
    apiKey: isTest
      ? process.env.NEXT_PUBLIC_NMI_API_KEY_SANDBOX
      : process.env.NEXT_PUBLIC_NMI_API_KEY,
    environment: isTest ? "test" : "production",
  };
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};
